import { createFileRoute, redirect } from '@tanstack/react-router'
import { SharedWithMePage } from '@/components/pages/SharedWithMePage'
import { FEATURES } from '@/lib/features'

export const Route = createFileRoute('/workspace/$slug')({
  beforeLoad: () => {
    // Only the single implicit workspace exists; /workspace/<anything> would
    // otherwise render a placeholder page for a workspace that is not real.
    if (!FEATURES.MULTIPLE_WORKSPACES) throw redirect({ to: '/workspace' })
  },
  component: WorkspaceSlugPage,
})

function WorkspaceSlugPage() {
  return <SharedWithMePage />
}
